import { makeActionCreator } from '../../../../utilities'
import { CardiacConstants } from './cardiac.constants'

export const setAction = makeActionCreator(CardiacConstants.SET_ACTION, 'action')
export const setLeadChange = makeActionCreator(CardiacConstants.SET_LEAD_CHANGE, 'leadChange')
export const setJoules = makeActionCreator(CardiacConstants.SET_JOULES, 'joules')
export const setDefibType = makeActionCreator(CardiacConstants.SET_DEFIB_TYPE, 'defibType')
export const setType = makeActionCreator(CardiacConstants.SET_TYPE, 'waveformType')
export const saveCardiac = makeActionCreator(CardiacConstants.SAVE_CARDIAC, 'data')
export const resetState = makeActionCreator(CardiacConstants.RESET_STATE)
export const resetToInitialState = makeActionCreator(CardiacConstants.RESET_TO_INITIAL_STATE)
export const setAddToTimeLine = makeActionCreator(CardiacConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setState = makeActionCreator(CardiacConstants.SET_STATE, 'cardiacState')
export const setDateTime = makeActionCreator(CardiacConstants.SET_DATE_TIME, 'time', 'date')
export const setAssessedBy = makeActionCreator(CardiacConstants.SET_ASSESSED_BY, 'assessedBy')
export const onSelectCardiacProcedure = makeActionCreator(CardiacConstants.ON_SELECT_CARDIAC)
export const setUpdateInputRows = makeActionCreator(CardiacConstants.SET_UPDATE_INPUT_ROWS, 'updateInputRows')
export const setSaveResponse = makeActionCreator(CardiacConstants.SET_SAVE_RESPONSE, 'saveResponse')
export const setSuccessfulAttempt = makeActionCreator(CardiacConstants.SET_SUCCESSFUL_ATTEMPT, 'successfulAttempt')
export const setAttempts = makeActionCreator(CardiacConstants.SET_ATTEMPTS, 'attempts')
export const setRolePerforming = makeActionCreator(CardiacConstants.SET_ROLE_PERFORMING, 'rolePerforming')
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  CardiacConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  CardiacConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
export const setMA = makeActionCreator(CardiacConstants.SET_MA, 'mA')
export const setHeartRate = makeActionCreator(CardiacConstants.SET_HEART_RATE, 'heartRate')
export const setPacingMode = makeActionCreator(CardiacConstants.SET_PACING_MODE, 'pacingMode')
export const setCompressionRate = makeActionCreator(CardiacConstants.SET_COMPRESSION_RATE, 'compressionRate')
export const setLocation = makeActionCreator(CardiacConstants.SET_LOCATION, 'location')
export const setMechanicalCprType = makeActionCreator(CardiacConstants.SET_MECHANICAL_CPR_TYPE, 'mechanicalCprType')
export const setCardiacDefaults = makeActionCreator(CardiacConstants.SET_CARDIAC_DEFAULTS, 'cardiacDefaults')
